<template>
  <div>
        <button
          class="btn btn-primary"
          v-on:click="abrirModal()"
          href="javascript:void(0)"
        >
          Chamados
        </button>

        <modal-planilhas-chamados @selecionado="downloadAnexo"/>
   </div>
</template>

<script>
import planilhasChamados from '../../modal/PlanilhasChamados.vue'

export default {
  components: {
    'modal-planilhas-chamados': planilhasChamados
  },
  data () {
    return {
      env: process.env,
      planilha: []
    }
  },
  methods: {
    abrirModal () {
      this.$store.commit('setPlanilhasChamados', {show: true})
    },
    downloadAnexo: function (bienio) {
      let grupo = ''
      if (localStorage.getItem('sessaoUsuario')) {
        let sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'))
        grupo = (sessaoUsuario.grupo.nome)
      } else {
        vm.$store.commit('setAlert', {msg: 'Ocorreu um erro ao recuperar as definições de segurança. Se persistir favor avisar ao Suporte SSP.', status: false, show: true})
        return
      }
      let vm = this
      let dados = ''
      if (grupo === 'adminVTAL') {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-adm/vtal/chamados-adm.csv'
        }
      } else {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': `predial-adm/chamados-${bienio}-adm.csv`
        }
      }
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getPlanilhasExternas`, dados, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', {msg: response.data.mensagem, status: false, show: true})
          return
        }
        window.open(response.data.url, '_blank')
      })
      // window.open(`${this.env.FINANCEIRO.SLA}/downloadExport/chamados`, '_blank')
      // let vm = this
      // this.$axios.post(`${this.env.FINANCEIRO.SLA}/downloadExport/chamados`, {
      //   headers: {
      //     'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
      //   }
      // }).then(function (response) {
      //   if (response.data.mensagem) {
      //     vm.$store.commit('setAlert', {msg: response.data.mensagem, status: false, show: true})
      //     return
      //   }
      //   window.open(response.data.url, '_blank')
      // })
    }
  }
}
</script>

<style scoped>
  button:hover {
    background-color: #6c757d;
  }
    /* button {
    background-color:#3c7fe4;
    color: white;
    margin: 1%;
    padding-left:15px;
    padding-right:15px;
    padding-bottom:5px;
    padding-top:5px;
    border-style: none;
    border-radius: 5px;
    width: 160px;
    height: 50px;
  } */
</style>



// WEBPACK FOOTER //
// ExportChamados.vue?b5125040